import { render } from "./EditRole.vue?vue&type=template&id=2c059be6&ts=true"
import script from "./EditRole.vue?vue&type=script&lang=ts"
export * from "./EditRole.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__